<template>
  <div class="tooltip-wrapper" :style="{'top': top, 'left': left, 'right': right, 'bottom': bottom}">
    <div class="tooltip" :class="{ 'tooltip-active': showTooltip }">
      <span class="tooltip-icon" v-if="haveIcon" :style="iconPosition === 'right' ? 'right: -17px;' : 'left: -17px;'">
        <ion-icon :name="icon"></ion-icon>
      </span>
      <div v-if="title" class="tooltip-header">
        <span class="title-tool">{{ title }}</span>
        <span class="close-tool" @click="onClick">
          <ion-icon name="close-outline"></ion-icon>
        </span>
      </div>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: "tooltip-default",
  props: {
    showTooltip: {
      default: false,
    },
    haveIcon: {
      default: false,
    },
    iconPosition: {
      default: ''
    },
    icon: {
      default: ''
    },
    title: {
      default: '',
    },
    top: {
      default: ''
    },
    bottom: {
      default: ''
    },
    left: {
      default: ''
    },
    right: {
      default: ''
    },
  },
  methods: {
    onClick() {
      this.$emit('close-tooltip')
    },
  },
}
</script>

<style lang="scss" scoped>

.tooltip-wrapper {
  position: absolute;
}

.tooltip {
  position: relative;
  background-color: #FFFFFF;
  padding: 15px 20px;
  border-radius: 10px !important;
  box-shadow: 0 2px 10px 2px rgba(53, 45, 165, 0.15);
  min-height: 250px;
  min-width: 300px;
  z-index: 1;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;

  &-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -25px;
    height: 50px;
    width: 50px;
    box-shadow: 0 2px 10px 2px rgba(53, 45, 165, 0.15);
    border-radius: 50% !important;
    background: #FFFFFF;

    ion-icon {
      color: #3A424E;
      font-size: 29px;
    }
  }

  &-header {
    position: relative;
    padding-bottom: 10px;
    margin-left: 18px;
    margin-right: 20px;
    border-bottom: 1px solid rgba(58, 66, 78, 0.22);

    .title-tool {
      font-weight: 500;
      font-size: 14px;
      color: #3A424E;
      margin-left: 1px;
    }

    .close-tool {
      ion-icon {
        position: absolute;
        right: -23px;
        top: 1px;
        font-size: 18px;
        color: #FF6075;
        cursor: pointer;
      }
    }
  }
}

.tooltip-active {
  opacity: 1;
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/tooltip/tooltip-default.vue